/**
 * Format an ISO timestamp as MM/DD/YY in UTC.
 *
 * UTC is used so the displayed date is stable across viewers regardless of
 * their local timezone — the FAQ approval date is a single point in time and
 * shouldn't shift based on who's looking at it.
 *
 * Returns the input unchanged if it can't be parsed as a date.
 */
export const formatApprovalDate = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const yy = String(d.getUTCFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
};
